<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="IP:">
                    <el-input v-model="form.ip_cidr" @keyup.enter.native="request" class="common-input"></el-input>
                </el-form-item>
                <el-form-item label="是否激活:">
                    <el-select v-model="form.is_active" placeholder="请选择" clearable class="common-input">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/ipWhiteAdd',query: { type:'add', callback:request } }">
                    <el-button type="primary" >新增</el-button>
                    <!--v-w-role="'ITSM-0079'"-->
                </router-link>

            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="IP" prop="ip_cidr" min-width="110">
                    <template slot-scope="scope">
                        <p v-for="item in scope.row.ip_cidr.split(',')">{{ item }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="是否激活" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.is_active  ? 'success' : 'danger'"
                            disable-transitions>
                            {{scope.row.is_active ? '是':'否'}}
                        </el-tag>

                    </template>
                </el-table-column>
                <el-table-column label="描述" prop="description" min-width="180"></el-table-column>
                <el-table-column label="创建人" prop="create_user" ></el-table-column>
                <el-table-column label="更新人" prop="update_user" ></el-table-column>
                <el-table-column label="创建时间" prop="create_time" min-width="140"></el-table-column>
                <el-table-column label="更新时间" prop="update_time" min-width="140"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="100">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/ipWhiteAdd',
                                        query: { type:'edit',row:scope.row,callback:request }}">
                            <el-button type="text" >编辑</el-button>
                        </router-link>
                        <el-button  class="table-del-btn" type="text" @click="delEvent(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.page_index"
                           :page-sizes="[10,20]"
                           :page-size="form.page_size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    import { openMessage } from "./system.config";
    import services from "./system.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    ip_cidr:'',
                    is_active:null,
                    page_size:10,
                    page_index:1,
                },
                total:null,
                tableData:[],
                loading:false,
            }
        },
        created() {
            this.request();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },


        },
        methods: {

            loadData(){
                this.form.page_index = 1;
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.request();
            },
            request(){
                // 获取列表数据
                services.getIpList(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            delEvent(val){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.getIpWhiteDel({ id:val }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
             openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.page_size = val;
                if(this.form.page_index > pages ){
                    this.form.page_index  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.page_index = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
